<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import Select2 from 'vue3-select2-component';
import Swal from "sweetalert2";

export default {
  page: {
    title: "Add Order",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Add Order",
      items: [
        {
          text: "Add Order",
          href: "/order/create",
        },
        {
          text: "Dropdown",
          active: true,
        },
      ],
        UrlToGrading: process.env.VUE_APP_LANDING+"/index.php#Grading",
        modelList:[{'id':'0','text': "Please Select Brand" }],
        loadsubmitOrder:false,
        Grade:'8',
        ListAddDeviceData:[],
        brandList:[],
        ListDataCondition:[],
        brand:'',
        category:'',
        model_:'0',
        quantityA:'1',
        
        // options:[],

        brandrequired:false,
        modelrequired:false,
        quantityrequired:false,
        morethan:false,
        isexpired:false,
        CanProceedStatusOrder:true,

        TotalDevice:'0',
        userId:'',
        apiCallTriggered:false,
        remarks:'',
        characterCount:50,
        // value: true,
        // value1: true,
        // value2: true,
        // value3: true,
        // value4: true,
        // maxlen: "",
        // data: "",
        // option: "",
        // textarea: "",
        // defaultNull: null,
        // defaultspinval: 1,
        categoryList:[
            {
                "text": "Laptop",
                "id": 1
            },
            {
                "text": "Mac",
                "id": 176208
            },
            {
                "text": "Macs",
                "id": 176208
            },
            {
                "text": "Others",
                "id": 176209
            },
            {
                "text": "Smartphones",
                "id": 38112
            },
            {
                "text": "Tablets",
                "id": 176207
            },
            {
                "text": "Watches",
                "id": 38522
            }
        ],  
    };
  },

    methods: {
        clearSession(){
        const posting_ = { status: "5" };
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.post(process.env.VUE_APP_API_BASEURL+'order/reupload/'+localStorage.getItem('orderId_priceCheck'), posting_)
        },

        Listcondition(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'condition')
			.then(response => {

				if (response) {
                    this.ListDataCondition = response.data;
                    // console.log(this.ListDataCondition);
                } else {
                    this.messageBag = ['No record.'];
                }
			})
                .catch(error => {
                    this.messageBag = [error.error];
			});
        },

        getBrand(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'device/brand')
            .then(response => {
                if (response) {
                    this.brandList=response.data;
                } else {
                    console.log('error');
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });
        },

        CategoryOnChangeSelected(){
            // alert('ad');

            this.deviceSelectionBrand();
            if(this.brand != '0'||this.brand == null){
                // alert('vb');
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                if(this.brand == null||this.brand == ''){
                    this.sqlUrl = process.env.VUE_APP_API_BASEURL+'device/brand/'+this.category;
                    
                }else{
                    this.sqlUrl = process.env.VUE_APP_API_BASEURL+'device/brand/' + this.brand+'/'+this.category;
                }
                axios.get(this.sqlUrl)
                .then(response => {
                    // alert('ga');
                    if (response) {
                        // alert('io');
                        // var jsonArray1 = [{'id':'','text': "doug"}];
                        this.modelList  = [{'id':'0','text': "Please select "+ this.brand +" model " }].concat(response.data);
                        // console.log(this.modelList);
                    } else {
                        console.log('error');
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                });
            }
        },

        CategorySelected(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'device/category')
            .then(response => {
                if (response) {
                    this.categoryList=response.data;
                } else {
                    console.log('error');
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });
        },

        deviceSelectionBrand(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'devicenew/brand/'+this.category)
            .then(response => {
                if (response) {
                    this.brandList=response.data;
                } else {
                    console.log('error');
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });
        },


        ModelSelected(e){
            this.model_='0';
            if(e.target.value != ''){
                if(this.category == '')
                {
                    this.categorySend = 'NONE';
                }else{
                    this.categorySend = this.category;
                }
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')

                if(this.brand == null||this.brand == ''){
                    this.sqlUrl = process.env.VUE_APP_API_BASEURL+'device/brand/'+this.category;
                    
                }else{
                    this.sqlUrl = process.env.VUE_APP_API_BASEURL+'device/brand/' + this.brand+'/'+this.category;
                }

                axios.get(this.sqlUrl)
                .then(response => {
                    if (response) {
                        // var jsonArray1 = [{'id':'','text': "doug"}];
                        this.modelList  = [{'id':'0','text': "Please select "+ e.target.value +" model " }].concat(response.data);
                        // console.log(this.modelList);
                    } else {
                        console.log('error');
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                });
            }
        },

        addDevice(e){
            this.IsSubmit = 0;
            this.brandrequired=false;
            this.modelrequired=false;
            this.morethan=false;
            this.quantityrequired=false;
            this.userId = localStorage.getItem('userid');

            if(this.quantityA > 1000){
                this.IsSubmit = '1';
                this.morethan = true;
            }
            // this.total_device_stop = this.totalPrice.value + this.quantityA.value;
            
            // if(this.total_device_stop > 10){
            //     console.log('xxx');
            //     console.log(this.totalPrice);
            //     console.log(this.quantityA);
            //     console.log(this.total_device_stop);
            // }
            // this.IsSubmit = '1';
            
            e.preventDefault();

            if(this.brand == ''){
                this.brandrequired = true;
                this.IsSubmit = '1';
            }

            if(this.model_ == '0'){
                this.modelrequired = true;
                this.IsSubmit = '1';
            }

            if(this.quantityA == ''|| this.quantityA== '0'){
                this.quantityrequired = true;
                this.IsSubmit = '1';
            }

            if(this.IsSubmit == '0'){
                const posting_ = { 
                    brand: this.brand,
                    model_: this.model_,
                    quantityA: this.quantityA,
                    condition: this.Grade,
                    userid: this.userId,
                    price_check: 0,
                };

                // console.log(posting_);
                // console.log(e);

                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.post(process.env.VUE_APP_API_BASEURL+'order/addorder', posting_)
                .then(response => {
                    if (response) {
                        if(response.data.status=='limit'){
                            
                            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                            axios.get(process.env.VUE_APP_API_BASEURL+'country/mycountry', posting_)
                            .then(response_phone => {
                                console.log(response_phone);
                                alert('Maximum quantity that can be saved is 1000 units.');
                            });
                            
                        }else{
                            // console.log(response.data);
                            this.brand='';
                            this.model_=0;
                            this.Grade='8';
                            this.quantityA='1';
                            this.modelList = [{'id':'0','text': "Please Select Brand" }];
                            this.ListAddDevice();
                        }
                        
                    }else{
                        this.ButtonSeen=false;
                        console.log('tak ok');
                    }
                });
            }
        },

        Getisexpired(OrderID){
            this.isexpired = false;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'order/isexpired/'+OrderID)
            .then(response => {
                if (response) {
                    if(response.data.status=='error'){
                        console.log(response.data);
                    }else{
                        this.isexpired = response.data
                    }
                } else {
                    console.log('error');
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });
        },

        ListAddDevice(){

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'order/addorder')
            .then(response => {
                if (response) {
                    if(response.data.status=='error'){
                        console.log(response.data.status);
                    }else{
                        this.ListAddDeviceData = response.data;
                        this.remarks = this.ListAddDeviceData['0'].cq_remarks;
                        
                        // console.log(response.data['0'].OrderId);
                        this.orderId_=response.data['0'].OrderId;
                        localStorage.setItem("orderId_addorder", response.data['0'].OrderId);
                        this.TotalDeviceAdding(response.data['0'].OrderId);
                        this.Getisexpired(response.data['0'].OrderId);

                        this.countCharacters(0);
                    }
                    
                    // console.log(this.ListAddDeviceData);
                } else {
                    console.log('error');
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });
            
        },

        TotalDeviceAdding(OrderId){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'order/TotalDevice/'+OrderId)
            .then(response => {
                if (response) {
                    this.TotalDevice = response.data.quantity;
                    this.totalPrice = response.data.total;
                    this.currency = response.data.currency;
                    // console.log(response.data);
                } else {
                    console.log('error');
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });

        },

        NumbersOnly(evt) {

            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        isData() {

            
            const plus = document.getElementsByClassName("plus");
            const minus = document.getElementsByClassName("minus");

            if (plus) {
                Array.prototype.forEach.call(plus, (e) => {
                e.addEventListener("click", (event) => {
                    let par = event.target.closest(".input-step");
                    par.getElementsByClassName("product-quantity")[0].value++;
                    // console.log('========');
                    // console.log(par.getElementsByClassName("product-quantity")[0].value);
                    this.quantityA = par.getElementsByClassName("product-quantity")[0].value;
                });
                });
            }

            if (minus) {
                Array.prototype.forEach.call(minus, (e) => {
                e.addEventListener("click", (event) => {
                    let par = event.target.closest(".input-step");
                    if (par.getElementsByClassName("product-quantity")[0].value > 0)
                    par.getElementsByClassName("product-quantity")[0].value--;
                    // console.log(par.getElementsByClassName("product-quantity")[0].value);
                    // console.log('********');
                    this.quantityA = par.getElementsByClassName("product-quantity")[0].value;
                });
                });
            }
        },

        editDevice(deviceId){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'order/addorder/'+deviceId)
            .then(response => {
                if (response) {
                    // this.detailDevice = response.data;
                    // this.brandedit=response.data.brand;
                    // this.modeledit=response.data.model;
                    // this.quantityedit=response.data.count;
                    this.DetailDevice = response.data;
                    // console.log(response.data);
                    
                    Swal.fire({
                        title: "Are you sure you want to delete this device?",
                        text: this.DetailDevice.brand +' '+this.DetailDevice.model+'('+this.DetailDevice.storage+')',
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#f46a6a",
                        cancelButtonColor: "#34c38f",
                        confirmButtonText: "Yes, Delete Device",
                    }).then((result) => {
                        if (result.value) {
                            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                            axios.get(process.env.VUE_APP_API_BASEURL+'order/delete/'+deviceId)
                            .then(response => {
                                if (response) {
                                    this.ListAddDevice();
                                    // console.log(response.data);
                                    Swal.fire("Deleted!", "Your Device has been Deleted.", "success");
                                }else{
                                    Swal.fire("Fail!", "Your Device Fail To Deleted. Please try again", "fail");
                                }
                            });
                            this.ButtonSeen=false;
                        }
                    });
                    
                } else {
                    console.log('error');
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });

            
        },


        ApproveButton() {
            
            Swal.fire({
                title: "Are you sure you want to submit this order?",
                // text: "You won't be able to revert!",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, Submit Order",
            }).then((result) => {
                if (result.value) {
                    this.loadsubmitOrder=true;
                    const posting_ = { status: "1", remarks:this.remarks, };
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.post(process.env.VUE_APP_API_BASEURL+'order/drowdownapprove/'+this.orderId_, posting_)
                    .then(response => {
                        // console.log(response.data);
                        if (response.data.status == 'successfully') {
                            Swal.fire({
                                title:"Order Confirmed!", 
                                html: "Our customer service will contact you soon.", 
                                icon:"success",
                            }).then(() => {
                                // console.log(response.data);
                                this.$router.push('/order/cq/'+this.orderId_); 
                            });
                        }else{
                            this.loadsubmitOrder=false;
                            Swal.fire("Fail!", "Your Order Failed To Be Added. Please try again", "fail");
                        }
                    });
                    this.ButtonSeen=false;
                }
            });
        },

        ClearButton(){
            
            Swal.fire({
                title: "Are you sure you want to clear this order?",
                // text: "You won't be able to revert!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#34c38f",
                confirmButtonText: "Yes, Clear Order!",
            }).then((result) => {
                if (result.value) {
                    const posting_ = { status: "5" };
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.post(process.env.VUE_APP_API_BASEURL+'order/reupload/'+this.orderId_, posting_)
                    .then(response => {
                        console.log(response.data);
                        if (response.data.status == "successfully") {
                            Swal.fire("Order Cleared!", "Your order data has been deleted.", "success").then(() => {
                                window.location.reload();
                            });
                            this.ListAddDevice();
                        }else if (response.data.status == "error") {
                            Swal.fire("Fail!", response.data.message, "fail");
                        }else{
                            Swal.fire("Fail!", "Your order data fail to be deleted. Please try again later", "fail");
                        }
                    });
                    
                }
            });
        },

        checkIfVoucher(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'voucher/isvoucer')
            .then(response => {
                // console.log(response.data);
                if(response.data == 'voucher'){
                    this.CanProceedStatusOrder = false;
                }
            });
        },

        countCharacters(from) {
            this.apiCallTriggered=true;
            this.characterCount = 50 - this.remarks.length;
            if(from == 1){
                clearInterval(this.timer);
                this.idleTime = 0;
                this.startIdleTimer();
            }
        },
        
        startIdleTimer(){
            if(this.apiCallTriggered == true){
                this.timer = setInterval(() => {
                    this.idleTime += 1000; // Increment idle time by 1 second
                    if (this.idleTime >= 3000 && this.apiCallTriggered == true) { // If idle for 3 seconds
                        this.saveremarksCQ();
                        
                    }
                }, 1000);
            }
        },

        saveremarksCQ(){
            const posting_ = { remarks:this.remarks, };
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'order/saveremarksCQ/'+this.orderId_, posting_)
            this.apiCallTriggered = false;
            console.log('ok');
        }

        
    },

  mounted() {
        this.checkIfVoucher();
        this.Listcondition();
        this.getBrand();
        this.CategorySelected();
        this.isData();
        this.ListAddDevice();
        // this.clearSession();

        
    },

  components: {
    Layout,
    PageHeader,
    Select2,
  },
};

</script>
<style>
    .select2-selection{
        height: 38px !important;
        width: 100% !important;
    }

    .select2-selection--single{
        padding-top: 5px;
    }

    #selecaku{
        padding-top: 5px;
    }
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    
    <div class="card">
        <div class="card-header align-items-center d-flex">
            <h4 class="card-title mb-0 flex-grow-1">Create Order</h4>
            <div><a target="_blank" :href="UrlToGrading" ><b>View Grading Guideline</b></a></div>
        </div>
        <div class="card-body">
            <div v-if="CanProceedStatusOrder == true">
                <table class="table table-nowrap">
                    <thead >
                        <th style="width: 20%">Category</th>
                        <th style="width: 20%">BRAND </th>
                        <th style="width: 30%">MODEL</th>
                        <th style="width: 15%"><center>GRADE</center></th>
                        <th style="width: 15%"><center>QUANTITY</center></th>
                        <th style="width: 10%"><center>ACTION</center></th>
                    </thead>
                    <tbody>
                        <tr v-if="!isexpired">
                            <td>
                                <span id="selecaku">
                                    <select v-model="category" class="form-select mb-3" @change="CategoryOnChangeSelected($event)" arial-label="Default select example" placeholder="Please Select Category" required>
                                        <option value="">Please Select Category</option>
                                        <option v-for="(itemad, indexda) in categoryList" :key="indexda" :value="itemad.text" >
                                            {{ itemad.text }}
                                        </option>
                                    </select>
                                </span>
                            </td>
                            <td>
                                <span id="selecaku">
                                    <select v-model="brand" class="form-select mb-3" @change="ModelSelected($event)" arial-label="Default select example" placeholder="Please Select Brand" required>
                                        <option value="">Please Select Brand</option>
                                        <option v-for="(itemad, indexda) in brandList" :key="indexda" :value="itemad.text" >
                                            {{ itemad.text }}
                                        </option>
                                    </select>
                                </span>
                            </td>
                            <td>
                                <Select2 v-model="model_" :options="modelList"></Select2>
                                <span class="text-danger" v-if="modelrequired">Please Select Model</span>
                            </td>
                            <td>
                                <span id="ListDataCondition">
                                    <select v-model="Grade" class="form-select mb-3" arial-label="Default select example" required>
                                        <option v-for="(item, indexd) in ListDataCondition" :key="indexd" :value="item.id" >
                                            {{ item.name }}
                                        </option>
                                    </select>
                                </span>
                            </td>
                            
                            <td>
                                <center>
                                    <div class="input-step">
                                        <button type="button" class="minus">–</button>
                                        <input
                                            v-model="quantityA"
                                            type="number"
                                            class="product-quantity"
                                            min="1"
                                            max='1000'
                                            maxlength="4"
                                            width="100%"
                                            
                                        />
                                        <button type="button" class="plus">+</button>
                                    </div><br>
                                        <span class="text-danger" v-if="morethan">Maximun quantity is 1000</span>
                                    
                                </center>     
                            </td>
                            <td>
                                <center>
                                    <button type="submit" @click="addDevice" class="btn btn-primary">Add To Cart</button>
                                </center>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table table-nowrap" v-if="ListAddDeviceData['0']">
                    <thead >
                        <th class='align-middle' style="width: 5%" >NO.</th>
                        <th class='align-middle' style="width: 40%">DEVICE</th>
                        <th class='align-middle' style="width: 10%"><center>CONDITION</center></th>
                        <th class='align-middle' style="width: 10%"><center>QUANTITY</center></th>
                        <th class='align-middle' style="width: 15%"><center>UNIT PRICE</center></th>
                        <th class='align-middle' style="width: 15%"><center>TOTAL PRICE</center></th>
                        <th class='align-middle' style="width: 5%"><center>ACTION</center></th>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in ListAddDeviceData" :key="index" class="content">
                            <td>{{ index+1 }}</td>
                            <td>{{ item.brand }} {{ item.text }}</td>
                            <td>
                                <center>{{ item.condition }}</center>
                            </td>
                            <td>
                                <center>{{ item.count }}</center>
                            </td>
                            <td>
                                <center>{{ currency }} {{ (item.price/item.count).toLocaleString('en-US') }}</center>
                            </td>
                            <td>
                                <center>{{ currency }} {{ item.price.toLocaleString('en-US') }}</center>
                            </td>
                            <td>
                                <center>
                                    <i @click="editDevice(item.id)" class="ri-delete-bin-4-line" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg" data-toggle="Delete"></i>
                                </center>
                            </td>
                        </tr>
                        <tr v-if="TotalDevice != 0">
                            <td colspan="2">
                                
                            </td>
                            <td>
                                <center>Total Quantity:</center>
                            </td>
                            <td ><center> <b>{{ TotalDevice }}</b></center></td>
                            <td><center>Total Estimate:</center></td>
                            <td colspan="1"><center> <b>{{ currency }} {{ totalPrice.toLocaleString('en-US') }}</b></center></td>
                            <td></td>
                        </tr>
                        <tr v-if="TotalDevice != 0">
                            <td colspan="4">
                                <div class="alert alert-danger alert-border-left alert-dismissible fade show" role="alert" v-if="isexpired">
                                    <i class="ri-alert-line me-3 align-middle fs-16"></i><strong>Order Expired</strong> <br>
                                    This order already expired due to exceed 14 days from the final quotation date.<br>
                                    Please click on clear button to create new order.
                                    <br>
                                </div>

                                <b>Remarks</b>
                                <textarea class="form-control" @input="countCharacters(1)" id="exampleFormControlTextarea5" v-model='remarks' rows="2" maxlength="50"></textarea>
                                <p>Max 50 Characters 
                                    <!-- &nbsp;&nbsp;&nbsp;&nbsp; Characters Count:{{ characterCount }} -->
                                </p>
                            </td>
                            <td colspan=2>
                                <span v-if="loadsubmitOrder">
                                    <div class="spinner-border text-success" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </span>
                                <center v-else>
                                    <button class="btn btn-outline-success waves-effect waves-light" @click="ApproveButton" type="button" v-if="!isexpired"> Accept </button> &nbsp;&nbsp;
                                    <button class="btn btn-outline-success waves-effect waves-light" @click="ClearButton" type="button"> Clear </button>
                                </center>   
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else>
                <div class="alert alert-danger alert-border-left alert-dismissible fade show" role="alert">
                    <i class="ri-alert-line me-3 align-middle fs-16"></i><strong>Order Still in draft</strong> <br>
                    Please clear draft order before creating a new order. Click <router-link to="/order/titu">here</router-link> to view draft order.
                </div>
            </div>

        </div>
    </div>
    
    <!-- <div class="modal fade bs-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                    
                <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabel">Edit Device</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"
                        aria-label="Close">
                    </button>
                </div>
                <div class="modal-body" v-if="DetailDevice">

                        <form @submit="addDevice">
                            <div class="row">
                                <div class="col-lg-6">
                                    <p class="card-subtitle text-muted mb-0">Brand</p>
                                    <h6 class="card-title">{{ DetailDevice.brand }}</h6>
                                    <br>
                                </div>
                                <div class="col-lg-6">
                                    <p class="card-subtitle text-muted mb-0">Model</p>
                                    <h6 class="card-title">{{ DetailDevice.model }}</h6>
                                    <br>

                                </div>
                                <div class="col-lg-6">
                                    <div class="form-floating">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="firstnamefloatingInput"
                                            placeholder="Enter your firstname"
                                        />
                                    <label for="firstnamefloatingInput">Quantity</label>
                                    </div>
                                </div>
                            
                            </div>
                        </form>
                </div>
            </div> 
        </div> 
    </div>  -->
    
    </Layout>
</template>